import { Consorcio } from "./consorcio";
import { ExpensaResumenLiquidacionGastosDto } from "./gasto";
import { UnidadFuncionalGastosPorcentaje, ServicioGasto, TipoGasto, DialogCargaMovimientoItem } from "./index";

export class SaveExpensaConfiguration1RequestDto {
  constructor(
    public readonly ComunidadId: number,
    public readonly ConsorcioId: number,
    public readonly TipoGastos: number[],
    public readonly InteresVencimiento: number,
    public readonly InteresMensual: number,
    public readonly MetodoRedondeoExpensa: number,
    public readonly ConceptosRecargo: number,
    public readonly NotaExpensas: string | null,
    public readonly NotaExpensasPie: string | null
  ) {}
}

export class SaveExpensaConfiguration2RequestDto {
  constructor(
    public readonly ConsorcioId: number,
    public readonly Porcentajes: UnidadFuncionalTipoGastoPorcentajeItemDto[]
  ) {}
}

export class ExpensaUnidadFuncionalGastosPorcentajeRequestDto {
  constructor (
      public readonly ComunidadId: number
  ) {}
}

export class ExpensaUnidadFuncionalGastosPorcentajeResponseDto {
  constructor (
    public readonly HayUfsSinCubrirTotal: boolean,
      public readonly Porcentajes: UnidadFuncionalTipoGastoPorcentajeItemDto[]
  ) {}
}

export class UnidadFuncionalTipoGastoPorcentajeItemDto {
  constructor (
      public readonly Id: number,
      public readonly UnidadFuncionalCodigo: string | null,
      public readonly UnidadFuncionalNumero: number,
      public readonly UnidadFuncionalTipo: string | null,
      public readonly TipoGastoPorcentajes: UnidadFuncionalGastosPorcentaje[]
  ) {}
}

export class SaveExpensaConfiguration3RequestDto {
  constructor(
    public readonly ComunidadId: number,
    public readonly ConsorcioId: number,
    public readonly TipoGastoServicios: ExpensaTipoGastoComunidadServicioGasto[]
  ) {}
}

export class ExpensaTipoGastoComunidadServicioGasto {
  constructor (
      public readonly TipoGastoComunidadId: number,
      public readonly TipoGasto: string | null,
      public Servicios: ServicioGasto[]
  ) {}
}

export class SaveExpensaLiquidacionRequestDto {
  constructor (
    public readonly ComunidadId: number,
    public readonly ConsorcioId: number,
    public readonly ImporteFondoOperativo: number,
    public readonly Observaciones: string | null,
    public readonly FechaExpensa: Date,
    public readonly FechaVencimiento: Date,
    public readonly FechaVencimiento2: Date,
    public EnviarExpensa: boolean,
    public PublicarExpensa: boolean,
    public readonly TipoMovimientoId: number,
    public readonly Gastos: number[]
  ) {}
}

export class SaveExpensaLiquidacionResponseDto {
  constructor (
    public readonly ExpensaCabeceraId: number,
    public readonly TiposGasto: TipoGasto[],
    public readonly HayUfsSinCubrirTotal: boolean,
    public readonly UfsLiquidacion: SaveExpensaLiquidacionItemDto[],
    public readonly EnvioExpensaResultado: string | null,
    public readonly ExpensaPeriodo: string | null,
    public readonly ExpensaTotal: number,
    public MetodoRedondeoExpensa: MetodoRedondeoExpensaEnum,
    public readonly HabilitarControlCaja: boolean
  ) {}
}

export enum MetodoRedondeoExpensaEnum {
  RedondeoPorEntero = 1,
  RedondeoPorDecimal = 2,
  RedondeoPorDecena = 3
}

export class SaveExpensaLiquidacionItemDto {
  constructor (
    public readonly UnidadFuncionalId: number,
    public readonly UnidadFuncionalCodigo: string | null,
    public readonly UnidadFuncionalNumero: number,
    public readonly UnidadFuncionalTipo: string | null,
    public readonly Propietario: string | null,
    public readonly Valores: SaveExpensaLiquidacionValorDto[],
    public readonly FondoOperativo: number,
    public readonly TotalPrimerVencimiento: number,
    public readonly TotalSegundoVencimiento: number,
    public readonly Redondeo1: number,
    public readonly Redondeo2: number,
    public readonly GastoId: number,
    public PermitirGenerarInteres: boolean
  ) {}
}

export class SaveExpensaLiquidacionValorDto {
  constructor (
    public readonly TipoGastoId: number,
    public readonly TipoGasto: string | null,
    public readonly Porcentaje: number,
    public readonly ImporteFondoOperativo: number,
    public readonly Importe: number,
    public readonly Importe2: number
  ) {}
}

export class SearchExpensaRequestDto {
  constructor (
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly FechaExpensaDesde: Date | null,
    public readonly FechaExpensaHasta: Date | null,
    public readonly FechaVencimientoDesde: Date | null,
    public readonly FechaVencimientoHasta: Date | null,
    public readonly MonedaId: number | null,
    public readonly ComunidadId: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class ExpensaDto {
  constructor (
    public readonly Id: number,
    public readonly EstadoId: number,
    public readonly ComunidadId: number,
    public readonly ComunidadNombre: string | null,
    public readonly ConsorcioId: number,
    public readonly Activo: boolean,
    public readonly Observaciones: string | null,
    public readonly ExpensaPeriodo: string | null,
    public readonly FechaExpensa: Date,
    public readonly FechaVencimiento: Date,
    public readonly FechaVencimiento2: Date,
    public readonly MonedaId: number,
    public readonly MonedaCodigo: string | null,
    public readonly ImporteFondoOperativo: number,
    public readonly Importe: number,
    public readonly Importe2: number,
    public readonly Editable: boolean,
    public MetodoRedondeoExpensa: MetodoRedondeoExpensaEnum,
    public readonly ConceptosRecargo: number,
    public readonly TipoGastosConceptosRecargo: ExpensaTipoGastoConceptoRecargoDto[],
  ) {}
}

export class ExpensaLiquidacionResumenDto {
  constructor (
    public readonly ExpensaCabecera: ExpensaDto,
    public readonly Consorcio: Consorcio,
    public readonly TiposGasto: TipoGasto[],
    public readonly HayUfsSinCubrirTotal: boolean,
    public readonly UfsLiquidacion: SaveExpensaLiquidacionItemDto[],
    public readonly GastosPeriodo: ExpensaResumenLiquidacionGastosDto[],
    
  ) {}
}

export class ExpensaTipoGastoConceptoRecargoDto {
  constructor (
      public readonly Id: number,
      public readonly TipoGastoId: number,
      public readonly TipoGasto: string | null,
      public readonly ExpensaId: number
  ) {}
}

export class SaveExpensaDto {
  constructor (
    public readonly Id: number,
    public readonly Activo: boolean,
    public readonly Observaciones: string | null,
    public readonly FechaVencimiento: Date,
    public readonly FechaVencimiento2: Date | null,
    public readonly ImporteFondoOperativo: number,
    public InteresVencimiento: number,
    public InteresMensual: number,
    public ConceptosRecargo: number,
    public TipoGastosConceptosRecargo: number[],
    public MetodoRedondeoExpensa: number,
    public readonly NotaExpensas: string | null,
    public readonly NotaExpensasPie: string | null
  ) {}
}

export class SaveExpensaMovimientoDeudaDto {
  constructor (
    public readonly Id: number,
    public readonly Deudas: DialogCargaMovimientoItem[]
  ) {}
}

export class DashboardMisExpensasRequestDto {
  constructor (
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly FechaExpensaDesde: Date,
    public readonly FechaExpensaHasta: Date,
    public readonly MonedaId: number,
    public readonly ComunidadId: number
  ) {}
}

export class DashboardMisExpensasItemDto {
  constructor (
    public readonly Id: number,
    public readonly FechaExpensa: Date,
    public readonly ComunidadId: number,
    public readonly ComunidadNombre: string | null,
    public readonly FechaVencimiento: Date,
    public readonly Moneda: string | null,
    public readonly Importe: number,
    public readonly MiImporte: number,
  ) {}
}

export class DialogExpensaGastosPeriodoComponentRequestDto {
  constructor(
    public readonly ExpensaCabecera: ExpensaDto,
    public readonly GastosPeriodo: ExpensaResumenLiquidacionGastosDto[]
  ) {}
}

export class DialogExpensaGastosPeriodoComponentResponseDto {
  constructor(
    public readonly Cancelled: boolean
  ) {}
}

export class SaveGastosPeriodoRequestDto {
  constructor(
    public readonly ExpensaId: number,
    public readonly EsSimulacion: boolean,
    public readonly Gastos: any[]
  ) {}
}